// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ClientBanner.module.css */
.ClientBanner_container__Vlk3h {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #e0e0e0;
  padding: 20px; /* Adaugă padding pentru spațiu în interior */
  box-sizing: border-box; /* Include padding și border în dimensiuni */
  overflow: hidden; /* Previne orice depășire a conținutului */
  height: 190px;
}

.ClientBanner_bannerContainer__nU0Ea {
  max-width: 1140px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* Permite rearanjarea elementelor */
  box-sizing: border-box; /* Gestionează dimensiunile complet */
}

.ClientBanner_textContainer__XW4xT {
  max-width: 70%;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box; /* Asigură respectarea dimensiunilor */
}

.ClientBanner_heading__j7MN- {
  font-size: 1.5rem;
  font-weight: normal;
  margin: 0;
  color: #333;
  word-wrap: break-word; /* Rupe cuvintele care sunt prea lungi */
}

.ClientBanner_highlight__cVL23 {
  color: #000;
  font-weight: bold;
}

.ClientBanner_subText__xoqFi {
  font-size: 1rem;
  color: #555;
  margin-top: 5px;
  word-wrap: break-word; /* Previne depășirea textului */
}

.ClientBanner_buttonContainer__ir4Oi {
  text-align: right;
  width: 100%; /* Asigură alinierea pe ecrane mici */
  box-sizing: border-box;
}

.ClientBanner_button__39iJB {
  background-color: #d8230f;
  color: #fff;
  border: none;
  padding: 12px 18px;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.ClientBanner_button__39iJB i {
  margin-left: 8px;
}

/* Media Query pentru ecrane mici */
@media (max-width: 768px) {
  .ClientBanner_container__Vlk3h {
    height: auto;
    padding: 10px; /* Evită depășirile */
  }

  .ClientBanner_bannerContainer__nU0Ea {
    flex-direction: column;
    align-items: flex-start;
  }

  .ClientBanner_textContainer__XW4xT {
    max-width: 100%;
    margin-bottom: 20px;
    text-align: left;
    box-sizing: border-box;
  }

  .ClientBanner_buttonContainer__ir4Oi {
    text-align: right;
    width: 100%; /* Menține alinierea la dreapta */
    padding-bottom: 10px;
  }

  .ClientBanner_button__39iJB {
    padding: 10px 15px;
    max-width: fit-content; /* Previi întinderea excesivă */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ClientBanner/ClientBanner.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,aAAa,EAAE,6CAA6C;EAC5D,sBAAsB,EAAE,4CAA4C;EACpE,gBAAgB,EAAE,0CAA0C;EAC5D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe,EAAE,oCAAoC;EACrD,sBAAsB,EAAE,qCAAqC;AAC/D;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB,EAAE,sCAAsC;AAChE;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,qBAAqB,EAAE,wCAAwC;AACjE;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB,EAAE,+BAA+B;AACxD;;AAEA;EACE,iBAAiB;EACjB,WAAW,EAAE,qCAAqC;EAClD,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kDAAkD;EAClD,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY;IACZ,aAAa,EAAE,qBAAqB;EACtC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,WAAW,EAAE,iCAAiC;IAC9C,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB,EAAE,+BAA+B;EACzD;AACF","sourcesContent":["/* ClientBanner.module.css */\n.container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: #e0e0e0;\n  padding: 20px; /* Adaugă padding pentru spațiu în interior */\n  box-sizing: border-box; /* Include padding și border în dimensiuni */\n  overflow: hidden; /* Previne orice depășire a conținutului */\n  height: 190px;\n}\n\n.bannerContainer {\n  max-width: 1140px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap; /* Permite rearanjarea elementelor */\n  box-sizing: border-box; /* Gestionează dimensiunile complet */\n}\n\n.textContainer {\n  max-width: 70%;\n  justify-content: flex-start;\n  align-items: flex-start;\n  box-sizing: border-box; /* Asigură respectarea dimensiunilor */\n}\n\n.heading {\n  font-size: 1.5rem;\n  font-weight: normal;\n  margin: 0;\n  color: #333;\n  word-wrap: break-word; /* Rupe cuvintele care sunt prea lungi */\n}\n\n.highlight {\n  color: #000;\n  font-weight: bold;\n}\n\n.subText {\n  font-size: 1rem;\n  color: #555;\n  margin-top: 5px;\n  word-wrap: break-word; /* Previne depășirea textului */\n}\n\n.buttonContainer {\n  text-align: right;\n  width: 100%; /* Asigură alinierea pe ecrane mici */\n  box-sizing: border-box;\n}\n\n.button {\n  background-color: #d8230f;\n  color: #fff;\n  border: none;\n  padding: 12px 18px;\n  border-radius: 5px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s, box-shadow 0.3s;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n}\n\n.button i {\n  margin-left: 8px;\n}\n\n/* Media Query pentru ecrane mici */\n@media (max-width: 768px) {\n  .container {\n    height: auto;\n    padding: 10px; /* Evită depășirile */\n  }\n\n  .bannerContainer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .textContainer {\n    max-width: 100%;\n    margin-bottom: 20px;\n    text-align: left;\n    box-sizing: border-box;\n  }\n\n  .buttonContainer {\n    text-align: right;\n    width: 100%; /* Menține alinierea la dreapta */\n    padding-bottom: 10px;\n  }\n\n  .button {\n    padding: 10px 15px;\n    max-width: fit-content; /* Previi întinderea excesivă */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ClientBanner_container__Vlk3h`,
	"bannerContainer": `ClientBanner_bannerContainer__nU0Ea`,
	"textContainer": `ClientBanner_textContainer__XW4xT`,
	"heading": `ClientBanner_heading__j7MN-`,
	"highlight": `ClientBanner_highlight__cVL23`,
	"subText": `ClientBanner_subText__xoqFi`,
	"buttonContainer": `ClientBanner_buttonContainer__ir4Oi`,
	"button": `ClientBanner_button__39iJB`
};
export default ___CSS_LOADER_EXPORT___;
